import { useTranslation, Trans } from '@framework/i18n';
import SharedTermsOfUse from '@framework/ui/Atoms/TermsOfUse';
import { namespaces } from '@/dealroadshow/ui/translations/namespaces';
import finsightWebUrl from '@/finsight/infrastructure/finsightWebUrl';

import ja from './locales/ja.json';
import en from './locales/en.json';

interface IProps {
  className?: string,
}

const TermsOfUse = ({ className }: IProps) => {
  useTranslation(namespaces.TERMS_OF_USE, { ja, en });

  return (
    <SharedTermsOfUse className={ className }>
      <Trans
        i18nKey={ `${ namespaces.TERMS_OF_USE }:termsAndPrivacyButtons` }
        components={ {
          br: <br />,
          termsOfUse: <a href={ finsightWebUrl.getTermsOfUseUrl() } target="_blank" />,
          privacyPolicy: <a href={ finsightWebUrl.getPrivacyPolicyUrl() } target="_blank" />,
        } }
      />
    </SharedTermsOfUse>
  );
};

export default TermsOfUse;
